// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"c22bb56c","966":"6a65e9b1"}[chunkId] + ".js";
};